import * as React from 'react';
import { Italic } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { Editor } from '@tiptap/react';

export const ItalicButton = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleItalic().run()}
         isActive={editor.isActive('italic')}
         isDisabled={!editor.can().toggleItalic()}
         icon={<Italic />}
         title={_js('Italic')}
         shortcut={'i'}
      ></TiptapButton>
   );
};
